import React, {useState } from 'react'
import {
    TableContainer,
    Table,
    TableRow,
    TableCell,
    TableBody,
    TableHead,
    Grid,
    Snackbar,
    IconButton
} from '@mui/material';
import '../styles/productDenomination.css'
import CloseIcon from '@mui/icons-material/Close';
import DenominationTable from "./DenominationTable";
import RangeDenomination from './RangeDenomination';
import Payment from '../payment/Payment';
import { useSelector } from 'react-redux';

export default function ProductDenomination() {
    const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    });

    const handleClose = () => {
        setSnackbar({ open: false, message: '' });
    };

    return (
        <Grid container sx={{
        }}>
            <Grid item xs={12} sm={12} md={7} lg={5}
                sx={{
                    borderRadius: {
                        xs: 2,
                        sm: 2,
                        lg: 3
                    },
                    mb: {
                        xs: 3,
                        sm: 0,
                        lg: 0
                    },
                    border: {
                        xs: 1,
                        sm: 0,
                        lg: 1
                    },
                    borderColor: {
                        xs: "lightSecondary.main",
                        lg: "lightSecondary.main",
                    },
                    boxShadow: {
                        xs: 0,
                        sm: 0,
                        lg: 1
                    },
                    maxHeight: {
                        xs: "400px",
                        sm: "650px",
                        lg:"auto"
                    },
                    overflowY: {
                        xs: "auto",
                        sm: "auto"
                    },
                    scrollbarWidth: "thin",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Range  */}
                {PRODUCTDETAILS.rangeDenomination && <RangeDenomination />}

                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    autoHideDuration={2000}
                    open={snackbar.open}
                    onClose={handleClose}
                    message={snackbar.message}
                    action={
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    }
                    sx={{
                        '.MuiSnackbarContent-root': {
                            backgroundColor: 'error.main',
                            fontSize: '13.5px',
                            fontWeight: 400,
                        },
                    }}
                />


                <TableContainer sx={{
                    maxWidth: {
                        xs: "100%",
                        lg: "80vw"
                    },
                }}>
                    <Table
                        className='product__denomination_table'
                        stickyHeader 
                        sx={{
                            minHeight: "30px",
                            minWidth: "100%",
                            maxWidth: '100%',
                        }}>
                        <TableHead>
                            <TableRow className='header'>
                                <TableCell align="center"
                                    sx={{
                                        fontSize: { xs: ".8rem", sm: "1rem", lg: "1rem" },
                                        textTransform: { xs: "capitalize", sm: "capitalize", lg: "capitalize", },
                                        color: { xs: "textPrimary.main", sm: "textPrimary.main" },
                                        minWidth: { xs: "40px" },
                                        px: { xs: 0, },
                                        fontWeight: { xs: 700, sm: 700, lg: 700 }
                                    }}
                                >Amount</TableCell>

                                <TableCell align="center"
                                    sx={{
                                        fontSize: { xs: ".8rem", sm: "1rem", lg: "1rem" },
                                        textTransform: { xs: "capitalize", sm: "capitalize", lg: "capitalize", },
                                        color: { xs: "textPrimary.main", sm: "textPrimary.main" },
                                        minWidth: { xs: "40px" },
                                        px: { xs: 0, },
                                        fontWeight: { xs: 700, sm: 700, lg: 700 }
                                    }}
                                >{PRODUCTDETAILS.productType}</TableCell>

                                <TableCell align="center"
                                    sx={{
                                        fontSize: { xs: ".8rem", sm: "1rem", lg: "1rem" },
                                        textTransform: { xs: "capitalize", sm: "capitalize", lg: "capitalize", },
                                        color: { xs: "textPrimary.main", sm: "textPrimary.main" },
                                        minWidth: { xs: "100px" },
                                        px: { xs: 0, },
                                        fontWeight: { xs: 700, sm: 700, lg: 700 }
                                    }}
                                >Quantity</TableCell>

                                <TableCell align="center"
                                    sx={{
                                        fontSize: { xs: ".8rem", sm: "1rem", lg: "1rem" },
                                        textTransform: { xs: "capitalize", sm: "capitalize", lg: "capitalize", },
                                        color: { xs: "textPrimary.main", sm: "textPrimary.main" },
                                        minWidth: { xs: "70px" },
                                        px: { xs: 0, },
                                        fontWeight: { xs: 700, sm: 700, lg: 700 }
                                    }}
                                >Total</TableCell>

                                {PRODUCTDETAILS.rangeDenomination &&
                                    <TableCell align="center"
                                        sx={{
                                            fontSize: { xs: ".8rem", sm: "1rem", lg: "1rem" },
                                            textTransform: { xs: "capitalize", sm: "capitalize", lg: "capitalize", },
                                            color: { xs: "textPrimary.main", sm: "textPrimary.main" },
                                            minWidth: { xs: "70px" },
                                            px: { xs: 0, },
                                            fontWeight: { xs: 700, sm: 700, lg: 700 }
                                        }}
                                    >Action</TableCell>
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <DenominationTable
                                setSnackbar={setSnackbar}
                                handleClose={handleClose}
                            />
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>


            {/* Order Receipt Component */}
            <Grid item xs={12} sm={12} md={5} lg={7} sx={{ px: { xs: 0, lg: 1 }, display: "flex", justifyContent: "center" }}>
                <Payment />
            </Grid>

        </Grid>
    );
}